<template>
    <div class="row py-5">
        <div class="col-12 px-5">
            <div class="row">
                <div class="col-12">
                    <h2>{{ $t("customer.customerDetail") }} - {{ customer.intern_id }}</h2>
                </div>
                <div>
                    <button v-if="hasPerm()" class="btn form-submit d-flex align-items-center justify-content-center"
                        style="height: 30px;" @click="changeToContact()">
                        <span style="font-size: 17px;">{{ customer.to_contact ? $t("customer.dontContact") :
                            $t("customer.toContact") }}</span>
                    </button>
                </div>
                <div class="col-12 col-md-6 mt-5">
                    <span>{{ $t("customer.firstName") }}: <b>{{ customer.first_name }} {{ customer.last_name
                            }}</b></span><br>
                    <span>{{ $t("customer.organizationId") }}: <b>{{ customer.organization_id }}</b></span><br>
                    <span>{{ $t("customer.organizationName") }}: <b>{{ customer.organization_name }}</b></span><br>
                    <span>{{ $t("customer.phone") }}: <b><a href="tel:{{ customer.whole_phone }}"
                                class="phone-number link-darker">{{
                                    customer.whole_phone }}</a></b></span><br>
                    <span>{{ $t("customer.email") }}: <b>
                            <a href="mailto:{{ customer.email }}" class="link-darker">{{ customer.email }}</a>
                        </b></span><br>
                    <span>{{ $t("customer.address") }}:
                        <b>
                            <a href="{{ customer.address ? customer.address.full_address : '#' }}" class="link-darker"
                                target="_blank">
                                {{ customer.address ? customer.address.full_address : '-' }}
                            </a>
                        </b>
                    </span> <br>
                    <span><b><a href="{{ customer.address.create_waze_link }}" class="link-darker" target="_blank">
                                {{ $t("customer.openWaze") }}
                            </a></b></span><br>
                    <div class="d-flex align-items-center">
                        <div class="me-2">
                            <span>{{ $t("customer.toContact") }}:</span>
                            <span v-if="customer.to_contact" class="ms-1">{{ $t("orders.yes") }}</span>
                            <span v-if="!customer.to_contact" class="ms-1">{{ $t("orders.no") }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-6 mt-5">
                    <div id="customer-map" style="height:300px; max-width: 100%;"></div>
                    <div ref="map"></div>
                </div>
                <div v-if="$store.getters.hasPerm('view_order')" class="">
                    <div class="col-12 mt-4">
                        <h3>{{ $t("customer.orderList") }}</h3>
                    </div>
                    <div class="col-12">
                        <div class="w-100 row py-4 item-line">
                            <div class="col-6 col-md-1">{{ $t("customer.id") }}</div>
                            <div class="col-6 col-md-2">{{ $t("customer.dateOfCreation") }}</div>
                            <div class="col-6 col-md-2">{{ $t("customer.dateOfDelivery") }}</div>
                            <div class="col-12 col-md-4">{{ $t("customer.address") }}</div>
                        </div>
                        <div v-for="order in orders" :key="order.id" class="w-100 row py-4 item-line">
                            <div class="col-6 col-md-1">{{ order.intern_id }}</div>
                            <div class="col-6 col-md-2">{{ order.created }}</div>
                            <div class="col-6 col-md-2">
                                <span>{{ order.expected_delivery_date }}</span>
                            </div>
                            <div class="col-11 col-md-3">
                                {{ customer.address ? customer.address.full_address : 'N/A' }}
                            </div>
                            <div class="col-1">
                                <a href="/order/{{ order.id }}/copy" class="button">{{ $t("utils.copy") }}</a>
                            </div>
                            <div class="col-1">
                                <router-link :to="{ name: 'OrderDetail', params: { id: order.id } }">
                                    {{ $t("utils.detail") }}
                                </router-link>
                            </div>
                            <div class="col-1">
                                <router-link :to="{ name: 'UpdateOrderItems', params: { id: order.id } }">
                                    {{ $t("utils.edit") }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 mt-3">
                    <FilesContainer :files="customer.files" :customerFileContainer="true" @uploadFile="uploadFile"
                        @deleteFile="deleteFile" @downloadFile="downloadFile" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FilesContainer from "@/components/FilesContainer.vue";
export default {
    components: {
        FilesContainer
    },
    data() {
        return {
            customerId: null,
            customer: {},
            orders: [],
            map: null,
        };
    },
    created: function () {
        this.customerId = this.$route.params.id;
        this.loadData();
    },
    methods: {
        loadData: function () {
            this.$store.getters.api
                .get("/customer/" + this.customerId)
                .then((response) => {
                    this.customer = response.data.customer;
                    this.orders = response.data.orders;
                    this.initializeMap();
                })
                .catch((response) => {
                    alert(this.$t("error." + response?.response?.data?.error_code));
                    var status = response?.response?.status;
                    if (status == 404) {
                        this.$router.push({ name: "Customers" });
                    }
                });
        },
        async initializeMap() {
            if (
                !this.customer.address ||
                !this.customer.address.gps_lat ||
                !this.customer.address.gps_lon
            ) {
                return;
            }

            const lat = this.customer.address.gps_lat;
            const lon = this.customer.address.gps_lon;

            // if map already exists, just update view and marker
            if (this.map) {
                this.map.setView([lat, lon], 15);
                this.marker.setLatLng([lat, lon]);
                return;
            }

            // create map
            this.map = L.map("customer-map").setView([lat, lon], 15);

            // load TileJSON from Mapy.cz
            const response = await fetch(
                "https://api.mapy.com/v1/maptiles/basic/tiles.json?apikey=vDDn3L5W7ZhRW9u7EowHsICpRmY_vEBMIqU00aGYydo"
            );

            const tileJson = await response.json();

            // add tile layer
            L.tileLayer(tileJson.tiles[0], {
                minZoom: tileJson.minzoom,
                maxZoom: tileJson.maxzoom,
                attribution: tileJson.attribution,
            }).addTo(this.map);

            // set marker
            this.marker = L.marker([lat, lon]).addTo(this.map);
        },
        changeToContact() {
            this.$store.getters.api.put("/customer/" + this.customerId + "/change_to_contact").then((response) => {
                this.loadData();
            });
        },
        hasPerm: function () {
            var perm = false;
            this.$store.state.user.functions.forEach(element => {
                if (element.name == "owner" || element.name == "dispatcher") {
                    perm = true;
                }
            })
            return perm;
        },
        uploadFile: function (data) {
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("file_type", data.file_type);
            formData.append("file", data.file);

            this.$store.getters.api.post("/customer/" + this.customerId + "/files/add", formData).then((response) => {
                this.loadData();
            })
        },
        deleteFile: function (id) {
            this.$store.getters.api.delete("/customer/" + this.customerId + "/files/" + id + "/delete").then((response) => {
                this.loadData();
            })
        },
        downloadFile: function (documentItem) {
            const fileName = documentItem.name || 'downloaded_document';

            this.$store.getters.api.get("/customer/" + this.customerId + "/files/" + documentItem.id + "/download", {
                responseType: 'blob'
            }
            ).then((response) => {
                if (response.data) {
                    const documentItem = response.data;

                    // Create a Blob URL using the provided Blob
                    const url = window.URL.createObjectURL(new Blob([response.data]));

                    // Create a link element to trigger the download
                    const link = window.document.createElement('a');

                    const fileExtension = documentItem.type.split('/')[1];  // Extract extension (e.g., 'pdf' from 'application/pdf')
                    link.href = url;

                    // Use the Blob type to determine the filename with extension
                    link.setAttribute('download', `${fileName}.${fileExtension}`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    this.loadData();
                }
            })
        }
    },
};
</script>
<style lang="scss"></style>